export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0-dev';
export const GIT_SHA = process.env.REACT_APP_GIT_SHA || 'local';
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
export const VERSION_LABEL =
  `v${APP_VERSION}` +
  (GIT_SHA && GIT_SHA !== 'local' ? ` · ${GIT_SHA}` : '') +
  (BUILD_TIME ? ` · ${BUILD_TIME.slice(0, 10)}` : '');
